import produce from 'immer';

import { FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED, UNSUBSCRIBE_SUCCEEDED, LOGOUT } from '../../constants/actionTypes';
import { SUBSCRIPTION_TYPE_VIP } from '../../../constants/payment';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED: {
      return action.payload.vip;
    }

    case UNSUBSCRIBE_SUCCEEDED: {
      if (action.payload.type === SUBSCRIPTION_TYPE_VIP) {
        draft.cancelledAt = action.payload.timestamp;
      }
      break;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
